import addNotification from '../actions/addNotification';
import removeNotification from '../actions/removeNotification';

export default function notificationsReducer(state = [], action) {
    switch (action.type) {
        case addNotification.type:
            return state.concat(action.payload);

        case removeNotification.type:
            return state.filter((notification) => notification !== action.payload);

        default:
            return state;
    }
}
